import { render } from "./loading-modal.vue?vue&type=template&id=1374c394&ts=true"
import script from "./loading-modal.ts?vue&type=script&lang=ts&external"
export * from "./loading-modal.ts?vue&type=script&lang=ts&external"

import "./loading-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__